import { useContext, useState } from "react";
import { Dropdowns } from "../../../../components/Dropdowns/Dropdowns";
import { DropdownsContext } from "../../../../contexts/DropdownsContext";
import "./AircraftSeatConfiguration.css";
import Input from "../../../../components/Inputs/Input";

const dropdownNames = {
  37: "templateId",
};
const hideFieldsWhenDisabled = new Set(["Template"]);
const defaultEmptyValues = {
  templateId: null,
};
const AircraftSeatConfiguration = ({ aircraftConfiguration }) => {
  const {
    dropdownsData,
    setDropdownsData,
    setDropdownIds,
    dropdownDefaultOptions,
  } = useContext(DropdownsContext);
  const [defaults, setDefaults] = useState({});
  const [values, setValues] = useState({ ...defaultEmptyValues });
  const handleDropdownValue = (value, name, data) => {};
  const updateDropdown = (dropdownId, parentValues, dependenciesToUpdate) => {
    setDropdownsData((prevDropdowns) =>
      prevDropdowns.map((filter) => {
        if (filter.id === dropdownId) {
          return {
            ...filter,
            parentValues,
            dependenciesToUpdate,
            reload: true,
          };
        }
        return filter;
      })
    );
  };
  const resetDropdownsReload = () => {
    setDropdownsData((filterState) => {
      if (filterState.length > 0) {
        return filterState.map((e) => {
          if (e.reload) {
            return { ...e, reload: false };
          }
          return e;
        });
      }
      return filterState;
    });
  };
  const changeValue = (e) => {};
  const doNothing = () => {};
  return (
    <div className="general-section-aircraft-seat-component">
      <div className="general-section-aircraft-seat-component-header">
        <div className="general-section-aircraft-seat-component-title">
          <b>Seat Configuration</b>
          <div className="general-info-actions">
              <button
                className="outlined iconTextButton small-size"
                onClick={() => doNothing()}
              >
                <i className="icon-edit"></i>
                <span>Edit</span>
              </button>
          </div>
        </div>
        <div className="general-section-aircraft-seat-component-buttons">
          <div className="general-section-aircraft-seat-component-title-selector">
            <p>Template</p>
            <Dropdowns
              context={{
                dropdownsData,
                setDropdownsData,
                setDropdownIds,
                dropdownDefaultOptions,
              }}
              updateDropdown={updateDropdown}
              resetDropdownsReload={resetDropdownsReload}
              hideWhenDisabled={hideFieldsWhenDisabled.has(dropdownNames[37])}
              disabled={true}
              key={37}
              onOptionSelect={(value, data) =>
                handleDropdownValue(value, dropdownNames[37], data)
              }
              showPagination={false}
              data={dropdownsData.find((e) => e.id === 37)}
              preSelectValue={defaults?.[dropdownNames[37]]}
            />
          </div>
          <div className="general-section-aircraft-seat-component-title-info">
            <div className="general-section-aircraft-seat-component-title-info-icon"></div>
            <p>There are 2 versions of this aircraft.</p>
          </div>
          <button className="filled iconTextButton">Template Creator</button>
          <div className="general-section-aircraft-seat-component-button-info">
            <p>View Seat Map Key</p>
            <div className="general-section-aircraft-seat-component-button-view-icon"></div>
          </div>
        </div>
      </div>
      <div className="general-section-aircraft-seat-component-body">
        <div className="general-section-aircraft-seat-component-body-template"></div>
      </div>
    </div>
  );
};

export default AircraftSeatConfiguration;
